export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/continuous_discovery_teams-3dcd5728e0c125a3441d362c9e186601.png";